import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response";

const useDeleteImage = () => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: (imageId: string) => request(`${sport}/o/${organizationId}/images/${imageId}`, { method: "DELETE" }),
    onSuccess: (response: DefaultOperationSuccessResponse) => {
      if (response?.data[0]?.success) {
        notification.success({
          message: formatMessage({ id: "image.clear.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};

export default useDeleteImage;
